var map = {
	"./rounded-back.webp": 261,
	"./rounded-bottom.webp": 262,
	"./rounded-corners.webp": 263,
	"./rounded-front.webp": 264,
	"./rounded-top.webp": 265,
	"./squared-corners.webp": 266,
	"./trapezoid-reversed.webp": 267,
	"./trapezoid.webp": 268
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;